var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "url(#paint0_linear_2568_51814)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35642 25.0872C8.97605 25.7244 8.12542 25.9368 7.46842 25.5717C6.80451 25.2067 6.58321 24.3902 6.96358 23.7596L7.95252 22.1201C9.06595 21.7948 9.97883 22.047 10.6911 22.8768L9.35642 25.0872ZM18.9623 21.5094H6.38266C5.62193 21.5094 4.99951 20.912 4.99951 20.1818C4.99951 19.4516 5.62193 18.8542 6.38266 18.8542H9.90967L14.4326 11.3402L13.0148 8.99039C12.6345 8.35315 12.8627 7.54333 13.5197 7.17825C14.1836 6.81317 15.0273 7.03222 15.4077 7.66281L16.0232 8.68504L16.6387 7.66281C17.019 7.02558 17.8697 6.81317 18.5267 7.17825C19.1906 7.54333 19.4119 8.35979 19.0315 8.99039L13.0978 18.8542H17.3925C18.7895 18.8542 19.5709 20.4274 18.9623 21.5094ZM25.7467 21.5094H23.7411L25.0966 23.7596C25.477 24.3968 25.2487 25.2067 24.5917 25.5717C23.9278 25.9368 23.0841 25.7178 22.7038 25.0872C20.4285 21.3102 18.7272 18.4692 17.5861 16.5841C16.4312 14.6591 17.2542 12.7341 18.0771 12.0836C18.9831 13.5904 20.3386 15.8473 22.1505 18.8542H25.7467C26.5074 18.8542 27.1298 19.4516 27.1298 20.1818C27.1298 20.9186 26.5074 21.5094 25.7467 21.5094Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2568_51814",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BD0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E71F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.e0fe2119d73cfc45862416e2b02e8b56.svg";
export { ForwardRef as ReactComponent };